import { render, staticRenderFns } from "./addExamsServiceDesk.view.vue?vue&type=template&id=2f92a9f4&scoped=true"
import script from "./addExamsServiceDesk.view.vue?vue&type=script&lang=js"
export * from "./addExamsServiceDesk.view.vue?vue&type=script&lang=js"
import style0 from "./addExamsServiceDesk.view.vue?vue&type=style&index=0&id=2f92a9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f92a9f4",
  null
  
)

export default component.exports